import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { IWizItemRenderer, WizBaseCollector, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { ALK_EVENT_TYPE } from '../../../../../model/enums';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'pivot-groupedit-item-renderer',
  templateUrl: './pivot-groupedit-item.renderer.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotGroupEditItemRenderer implements IWizItemRenderer<null, PivotField> {
  @HostBinding('style.width') forcedWidth = '100%';
  
  public data: PivotField;

  @Input()
  owner: WizBaseCollector;


  constructor(public elementRef: ElementRef) {}

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    // TODO contrôle de cohérence de la pile
    const toDie: PivotField = this.data;
    this.owner.wizDataProvider.getSource().forEach((pf: PivotField) => {
      if(pf.parentGroup === toDie.fkd.code) {
        pf.parentGroup = null;
      }
    });
    this.owner.wizDataProvider.removeItem(toDie);
    WizEventManager.dispatchEvent(this.owner.elementRef, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.data));
  }

  /** ouverture de la sub-pop pour configurer la formule (et à terme, le style) */
  public showConf(): void {
    WizEventManager.dispatchEvent(
      this.owner.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.PIVOT_CONFIGURE_GROUP_FIELD, [this.data, this.owner])
    );
  }

  public get fullLabel(): string {
    let res: string = this.data.labelOrDefaultLabel + ' (' + this.data.fkd.code + ')' ;
    if (!!this.data.parentGroup) {
      res = this.data.parentGroup + ' => ' + res;
    }
    return res;  
  }

}
